import React from "react";

import type useRemoveMessagesAfterStream from "services/dbApi/hooks/useRemoveMessagesAfterStream";

export interface UploadProgress {
  chatId: string;
  fileName: string;
  status: "uploading" | "complete" | "error";
  percentCompleted?: number;
  errorMessage?: string;
}

/**
 * Upload progress mapped by chatId and fileName.
 * chatId -> fileName -> UploadProgress (for a particular file)
 */
export type UploadProgressMap = {
  [chatId: string]: { [fileName: string]: UploadProgress };
};

export type UploadState = [
  uploads: UploadProgressMap,
  setUploads: React.Dispatch<React.SetStateAction<UploadProgressMap>>
];

export const UploadContext = React.createContext<UploadState | null>(null);

/** For `useUploadFile`'s `handleDelete`. See `RemoveFileMessageProvider`. */
export const RemoveFileMessageContext = React.createContext<ReturnType<
  typeof useRemoveMessagesAfterStream
> | null>(null);
